/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Contact_BodyInputs */

const en_about_contact_body = /** @type {(inputs: About_Contact_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We’d like to hear where the day gets repetitive.`)
};

const lv_about_contact_body = /** @type {(inputs: About_Contact_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labprāt uzzinātu, kuri darbi Jūsu ikdienā atkārtojas.`)
};

/**
* | output |
* | --- |
* | "We’d like to hear where the day gets repetitive." |
*
* @param {About_Contact_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_contact_body = /** @type {((inputs?: About_Contact_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Contact_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_contact_body(inputs)
	return en_about_contact_body(inputs)
});